import { PRODUCTS, hasProduct, type TenantProducts } from '@/lib/auth/products';

export type LoginProduct = 'merchantCredit' | 'deviceFinancing';

/**
 * `pay_in_installments` wins when present: MazeedPay holds both only because
 * offerings-service's blanket `device_financing` gate would 403 the portal
 * without it.
 */
export function primaryLoginProduct(
  products: TenantProducts
): LoginProduct | null {
  if (hasProduct(PRODUCTS.payInInstallments, products)) return 'merchantCredit';
  if (hasProduct(PRODUCTS.deviceFinancing, products)) return 'deviceFinancing';
  return null;
}
